import { Box, Typography } from '@mui/material'
import { Person20Regular } from '@/components/Icon'
import styles from './accountMenu.module.scss'

function AccountMenuHeader({ accountFullName, accountEmail }) {
  return (
    <Box className={styles.accountPopoverHeader}>
      <Box className={styles.accountPopoverIcon} aria-hidden>
        <Person20Regular className={styles.accountPopoverPersonIcon} />
      </Box>
      <Box className={styles.accountPopoverText}>
        <Typography component="p" className={styles.accountPopoverName}>
          {accountFullName}
        </Typography>
        <Typography component="p" className={styles.accountPopoverEmail}>
          {accountEmail}
        </Typography>
      </Box>
    </Box>
  )
}

export default AccountMenuHeader
